export function isObject(thing){
	return ({}).toString.call(thing) === '[object Object]';
}